/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface RedirectToLongUrl$Params {
  shortUrlSlug: string;
}

export function redirectToLongUrl(http: HttpClient, rootUrl: string, params: RedirectToLongUrl$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, redirectToLongUrl.PATH, 'get');
  if (params) {
    rb.path('shortUrlSlug', params.shortUrlSlug, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

redirectToLongUrl.PATH = '/api/v1/goto/{shortUrlSlug}';
